import Auth from "../_pages/Auth";

const PublicRoutes = [
  {
    path: "/login",
    element: <Auth />,
  },
];

export default PublicRoutes;
